module.exports = __webpack_public_path__ + "politize--0c532760.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/parceiros/politize.png
// module id = 240
// module chunks = 0